import React from "react";
import "./CustomComponentStyles.css";

  const DropdownCust = ({ id, name, value, onChange, placeholder, children, disabled }) => {
    return (
      <div className="dropdown-cust-container">
        <select
          name={name}
          id={id}
          className="dropdown-cust"
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          <option value="" disabled selected hidden>
            {placeholder}
          </option>
          {children}
        </select>
      </div>
    );
  };

export default DropdownCust;
